import styled from 'styled-components';

export default styled.div`
  grid-area: shipping;
  padding-bottom: 1rem;
  font-size: 0.8rem;
`;
